import React from 'react';

// eslint-disable-next-line max-len
const WREN_LOGO = '/themes/theme/wren/logo.png';
const WREN_GREEN_LOGO = '/themes/theme/wren/logo_on_green.png';

const WRENTheme = {
  headerLogo: {
    src: WREN_LOGO,
    alt: 'WREN Logo',
    size: 80,
  },
  darkLogo: {
    src: WREN_GREEN_LOGO,
    alt: 'WREN Logo',
    size: 80,
  },
  linkStyle: {
    color: '#fff',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#26a85d',
    borderBottom: '4px solid #26a85d',
    height: 80,
  },
  title: 'Wren Kitchens',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        width="40%"
        src={WREN_GREEN_LOGO} alt="WREN Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://wrenr.dyzio.co',
  isFullWhiteLabel: true,
};

export default WRENTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/wren.js
 **/